import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const HERO_IMG = "/images/camion-principal.png";
const LOGO_URL = "/images/logo-pierre-affretement.png";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};
const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Logistique Pierre Affrètement"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a2e48]/50 via-[#1a2e48]/20 to-transparent" />
        <div className="absolute inset-0" style={{background:"linear-gradient(to top,#1a2e48 0%,rgba(26,46,72,0.05) 20%,transparent 40%)"}} />
      </div>

      <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-[#E8902A]/6 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12 w-full pt-28 pb-16 md:pt-32 md:pb-24">
        <div className="flex justify-start">
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="max-w-xl text-left"
          >
            {/* Logo au-dessus du texte */}
            <motion.div variants={item} className="mb-5">
              <img
                src={LOGO_URL}
                alt="Pierre Affrètement"
                className="object-contain"
                style={{ mixBlendMode: "screen", height: "clamp(80px, 18vw, 148px)" }}
              />
            </motion.div>

            {/* Label */}
            <motion.div variants={item} className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-[#E8902A]" />
              <span
                className="font-heading font-bold text-xs tracking-widest uppercase text-[#E8902A]"
                style={{textShadow:"0 1px 8px rgba(0,0,0,0.9)"}}
              >
                Commissionnaire de Transport — Vichy (03)
              </span>
            </motion.div>

            {/* Headline */}
            <motion.h1
              variants={item}
              className="font-heading font-black text-4xl md:text-6xl lg:text-7xl text-white leading-[0.95] uppercase mb-6"
            >
              L’Expertise
              <br />
              <span className="gradient-text">Transport</span>
              <br />
              <span className="text-2xl md:text-3xl font-heading font-bold text-slate-200 normal-case" style={{letterSpacing:'0'}}>au cœur de l’Auvergne</span>
            </motion.h1>

            {/* Subtext */}
            <motion.p
              variants={item}
              className="text-slate-300 text-base md:text-lg leading-relaxed mb-8 max-w-lg"
            >
              Nous simplifions vos expéditions, réduisons vos coûts et connectons votre entreprise au monde entier avec fiabilité et expertise.
            </motion.p>

            {/* Localisation */}
            <motion.div variants={item} className="flex items-center gap-2">
              <MapPin size={16} className="text-[#E8902A]" />
              <span className="font-heading font-semibold text-sm text-slate-300 tracking-wide">
                Basé à Vichy (03) — France
              </span>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
